import React from "react";

const LocationDropdown = ({ locations, selectedLocationId, onChange }) => {
    const safeLocations = Array.isArray(locations) ? locations : [];

    return (
        <div
            className="dashboard-location-form"
            style={{ margin: 0 }}>
            <label
                htmlFor="location-select"
                className="dashboard-location-label">
                Location:
            </label>
            <select
                id="location-select"
                className="dashboard-location-select"
                value={selectedLocationId}
                onChange={(e) => onChange(e.target.value)}
                disabled={safeLocations.length === 0}>
                <option value="">Select a location</option>
                {safeLocations.map((loc) => (
                    <option
                        key={loc.id}
                        value={loc.id}>
                        {loc.name}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default LocationDropdown;
